<template lang="pug">
  y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(flat)
      v-card-title.pa-4
        div.h6.primary500--text {{ $t('edit_date') }}
        v-spacer
        v-btn(color="transparent" icon small @click="showModal = !showModal")
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-text.px-2.pb-2
        div.p1.basic700--text.px-2(v-if="yezzaShipping") {{ $t('select') }} {{ yezzaShipping.fulfilment.meta_data.service_type }} {{ $t('date') }}:
        div.p1.basic700--text.px-2 {{ selectedDate }} 
        v-date-picker(v-model="date" no-title)
          v-btn.mt-4(color="success500" depressed height="40" @click="clickSave" :loading="isLoading" dark block)
            .button-AA-medium.basic100--text.mx-2 {{ $t('save_changes') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EditDateGroup',
  props: ['open', 'parentYezzaShippings'],
  data: (vm) => ({
    dialogOpen: vm.dialog,
    date: null,
    isLoading: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    yezzaShippings: {
      get () {
        return this.parentYezzaShippings
      },
      set (newValue) {
        this.$emit('update:parentYezzaShippings', newValue)
      }
    },
    yezzaShipping () {
      if (this.yezzaShippings.length > 0) {
        return this.yezzaShippings[0]
      }
      return null
    },
    selectedDate () {
      if (this.date) {
        return this.convertDate(this.date)
      }
      return null
    }
  },
  mounted () {
    if (this.yezzaShipping.delivery_at) {
      this.date = this.yezzaShipping.delivery_at.substr(0, 10)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave () {
      this.isLoading = true
      let deliveryAt = this.date + ' 08:00:00'
      let data = {
        shippings: [...this.yezzaShippings.map(m => m.shipping)],
        delivery_at: deliveryAt
      }
      this.$axios.post('/shipping/yezzashipping/bulk', data)
        .then(resp => {
          this.$emit('update', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    convertDate (val) {
      const today = new Date(new Date().getTime() + (0 * 24 * 60 * 60 * 1000))
      const tomorrow = new Date(new Date().getTime() + (1 * 24 * 60 * 60 * 1000))
      const todaydate = today.getFullYear() + '-' + this.addLeadingZero((today.getMonth() + 1), 2) + '-' + this.addLeadingZero(today.getDate(), 2)
      const tomorrowdate = tomorrow.getFullYear() + '-' + this.addLeadingZero((tomorrow.getMonth() + 1), 2) + '-' + this.addLeadingZero(tomorrow.getDate(), 2)
      if (val === todaydate) {
        return 'Today'
      }
      if (val === tomorrowdate) {
        return 'Tomorrow'
      }
      if (val === '') {
        return '-'
      }
      if (!val) {
        return 'Close'
      }
      const d = new Date(val)
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      const newDate = days[d.getDay()] + ', ' + this.addLeadingZero(d.getDate(), 2) + ' ' + months[d.getMonth()]
      return newDate
    },
    addLeadingZero (str, count) {
      str = String(str)
      const len = str.length
      if (len < count) {
        for (let index = 0; index < count - len; index++) {
          str = '0' + str
        }
        return str
      }
      return str
    }
  }
}
</script>

<style scoped>
::v-deep .v-date-picker-title__year{
  display: none;
}
::v-deep .v-date-picker-title__date {
  display: none;
}
::v-deep .v-picker__title {
  padding: 0;
}
::v-deep .v-picker__body{
  width: 100% !important;
}
::v-deep .v-date-picker-header{
  height: 61px;
}

::v-deep .v-date-picker-header > button{
  position: absolute !important;
  width: 24px;
  border-radius: 5px;
  color: black !important; /*change month and arrow color*/
}

::v-deep .v-date-picker-header > button[aria-label="Previous month"],
::v-deep .v-date-picker-header > button[aria-label="Previous year"]{
  right: 53px;
}

::v-deep .v-date-picker-header > button[aria-label="Next month"],
::v-deep .v-date-picker-header > button[aria-label="Next year"]{
  right: 24px;
}

::v-deep .v-date-picker-header > div{
  position: absolute !important;
}

::v-deep .v-date-picker-header .v-date-picker-header__value button::after{
  font-family: "Material Design Icons";
  content: "\F0140";
  margin-left: 12px;
}
::v-deep .v-date-picker-table th {
  font-size: 15px;
  color: rgba(143, 155, 179, 1) !important; /*change days name color text*/
  height: 44px;
  border-bottom: 1px solid rgb(244,244,244);
  border-top: 1px solid rgb(244,244,244);
}

::v-deep .v-date-picker-table--date {
  height: 290px;
  padding: 0 8px 0 8px;
}

::v-deep .v-date-picker-table .v-btn {
  height: 44px;
  width: 44px;
  font-size: 15px !important;
  font-weight: 600;
  border-radius: 4px !important;
}
::v-deep .v-date-picker-table__current{
  border: 2px solid black; /*change current date color border*/
  color: black !important;
  background-color: rgba(51, 51, 51, 0.08); /*change current date color bg*/
}
::v-deep .v-date-picker-table .v-btn.v-btn--disabled {
  color:rgba(143, 155, 179, 1) !important; /*change disabled date color text*/
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  background-color: rgba(102, 144, 255, 1); /*change active/selected date color bg*/
}

::v-deep .v-date-picker-table--date .v-date-picker-table__events{
  bottom: 12px;
}

::v-deep .v-date-picker-table__events > div{
  width: 5px;
  height: 5px;
}

::v-deep .v-date-picker-table--month td .v-btn {
  margin: 0 auto;
  max-width: 140px;
  min-width: 40px;
  width: 100%;
  font-size: 15px !important;
  font-weight: 600 !important;
}
::v-deep .v-date-picker-years {
  font-size: 15px;
  font-weight: 600;
  height: 290px;
  list-style-type: none;
  overflow: auto;
  text-align: center;
}
</style>

<i18n>
{
  "en": {
    "edit_date": "Edit date",
    "select": "Select",
    "date": "date"
  },
  "id": {
    "edit_date": "Mengubah tanggal",
    "select": "Pilih",
    "date": "tanggal"
  }
}
</i18n>